import React from "react";
import styled from "styled-components";
import useTimeHook from "../../../common/hooks/useTimeHook";
import {useSelector} from "react-redux";

const StyledImage1 = styled.img`
    width: 160px;
    height: 90px;
`;

const TitleInfoSpan = styled.span`
    color: ${props => props.theme.color.dark_300};
    font-size: 10px;
    font-family: Pretendard;
    font-weight: 600;
    word-wrap: break-word;
`;

const TitleInfoP = styled.p`
    justify-content: center;
    display: flex;
    flex-direction: column;
`;

const TitleDate = styled.span`
    color: ${props => props.theme.color.dark_300};
    font-size: 10px;
    font-family: Pretendard;
    font-weight: 400;
    word-wrap: break-word;
`;

const TitleSplit = styled.span`
  color: ${props => props.theme.color.dark_300};
  font-size: 10px;
  font-family: Pretendard;
  font-weight: 400;
  word-wrap: break-word;
`;


const TitleSpan = styled.span`
    color: ${props => props.theme.color.dark_100};
    font-size: 18px;
    font-family: Pretendard;
    font-weight: 700;
    word-wrap: break-word;
`;



const StyledSpan = styled.span`
    color: ${props => props.theme.color.dark_200};
    font-size: 14px;
    font-family: Pretendard;
    font-weight: 500;
    word-wrap: break-word;
    line-height: 20px;
    word-break: keep-all;
`;


const TitleInfoBox = styled.div`
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
    display: inline-flex;
`;

const TitleBox = styled.div`
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    display: inline-flex;
`;

const ItemBox = styled.div`
    width: 332px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    display: inline-flex;
`;

const Wrapper = styled.button`
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    display: inline-flex;
    text-align: left;
`;

export const HomeNoticeItem = ({tag, title, time, url,imgUrl,subTitle}) => {
    const {lessMinWithIntl} = useTimeHook()
    const currentLang = useSelector((state) => state.translation.lang);

    // <ItemWrapper>
    //     <ContentWrapper>
    //         <TitleWrapper onClick={() => window.open(url)}>
    //             {title}
    //         </TitleWrapper>
    //     </ContentWrapper>
    //     <DateWrapper>
    //         {lessMinWithIntl(new Date(time), currentLang)}
    //     </DateWrapper>
    // </ItemWrapper>

    return (
        <Wrapper onClick={() => window.open(url)}>
            <StyledImage1 src={imgUrl}/>
            <ItemBox>
                <TitleInfoBox>
                    <TitleInfoP><TitleInfoSpan>게임 업데이트</TitleInfoSpan></TitleInfoP>
                    <TitleInfoP><TitleSplit>|</TitleSplit></TitleInfoP>
                    <TitleInfoP><TitleDate>{lessMinWithIntl(new Date(time), currentLang)}</TitleDate></TitleInfoP>
                </TitleInfoBox>
                <TitleBox>
                    <TitleInfoP><TitleSpan>{title}</TitleSpan></TitleInfoP>
                </TitleBox>
                <TitleInfoP><StyledSpan>{subTitle}</StyledSpan></TitleInfoP>
            </ItemBox>
        </Wrapper>
    );
};